import { BaseManager } from '../base/manager';
import { STORE_NAMES } from '../config';

import { IFilter } from '~/IFilter';

export class FilterManager extends BaseManager<IFilter> {
  constructor() {
    super(STORE_NAMES.filter);
  }

  protected generateKey(filter: IFilter): string {
    return filter.userKey
      ? `${filter.companyId}-${filter.userKey}-${filter.id}`
      : filter.id;
  }

  async getByUser(companyId: string, userKey: string): Promise<IFilter[]> {
    const allFilters = await this.getAll();
    return allFilters?.filter((filter) => filter?.companyId === companyId && filter?.userKey === userKey) || [];
  }

  async saveFilter(filter: IFilter): Promise<void> {
    return this.save(filter);
  }

  async getFilter(key: string): Promise<IFilter | undefined> {
    return this.get(key);
  }

  async deleteFilter(key: string): Promise<void> {
    return this.delete(key);
  }

  async getAllFilters(companyId: string, userKey: string): Promise<IFilter[]> {
    return this.getByUser(companyId, userKey);
  }
}

// Export singleton instance
export const indexedDbFilterManager = new FilterManager();
